export default __webpack_public_path__ + "static/media/Chevron_right_BG.2de04229.svg";